import "./Portfolio.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EditorialGallery from "./sections/EditorialGallery";
import SiteFooter from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <MainNavigation />
      <EditorialGallery />
      <SiteFooter />
    </div>;
}